module.exports = __webpack_public_path__ + "static/img/spot_5.ccfccaf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spot_5.jpg
// module id = SUot
// module chunks = 0